import React, { lazy } from 'react';
// layouts
import { ArrowDownward, ArrowUpward, DirectionsBus, LocalTaxi, Pages, PeopleAlt, QueryStats, Settings } from '@mui/icons-material';
//
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';
import { Box } from '@mui/material';
import { PATH_DASHBOARD } from './paths';


export const UnauthenticatedRoutes = [
  {
    exact: true,
    path: '/fulfillmentconfirmation',
    component: lazy(() => import('../components/igtm/fulfillmentInput/ConfirmBooking'))
  },
];

export const CommonRoutes = [
  {
    exact: false,
    path: '/app',
    component: () => <Redirect to="/" />
  },
  {
    exact: false,
    path: '/auth/login',
    component: () => <Redirect to="/" />
  },
  {
    exact: false,
    path: '*',
    component: lazy(() =>  import('../views/Page404'))
  }
];

export const getRootAdminRoutes = (profile,brand) => {
  
  const {textContent} = brand;
  return [
      {
        exact: true,
        path: PATH_DASHBOARD.general.dashboardHome,
        component: lazy(() => import('../components/igtm/RootAdmin/RootAdminConfig/RootAdminDash')),
        title: textContent.rootNavAdmin,
        icon: <Pages/>
      },
      {
        exact: true,
        path: PATH_DASHBOARD.general.configPage,
        component: lazy(() => import('../components/igtm/RootAdmin/RootAdminConfig/RootAdminDash')),
        title: textContent.rootNavConfig,
        icon: <Settings/>
      },
      {
        exact: true,
        path: PATH_DASHBOARD.general.schoolPage,
        component: lazy(() => import('../components/igtm/DetailViews/SchoolDetail/SchoolDetailContainer')),
        mainNav:false
      },
    ];
  }

export const getTravelCoRoutes = (profile,brand,selectorContext) => {
  
  const {textContent} = brand;
  const nav = [
    {
      exact: true,
      path: PATH_DASHBOARD.general.dashboardHome,
      component: lazy(() => import('../views/DashboardHome')),
      mainNav:false,
    }
  ];
  console.log(selectorContext);
  if(selectorContext) {
    if (selectorContext.unit) {
      console.log(selectorContext.unit);
      nav.push(
        {
          exact: true,
          path: PATH_DASHBOARD.general.configPage,
          component: lazy(() => import('../views/ConfigPage')),
          title:textContent.rootNavConfig,
          icon: <Settings/>
        },
        {
          exact: true,
          path: PATH_DASHBOARD.general.coachBookingsDash,
          component: lazy(() => import('../components/igtm/ReportViews/CoachBookings/CoachBookingsDash')),
          title:textContent.navBarCoaches,
          icon: <DirectionsBus/>
        },
      );
      
    }
  }
  return nav;
};


export const getFPCoRoutes = (profile,brand,selectorContext) => {
 
  const {textContent} = brand;
  const nav = [
    {
      exact: true,
      path: PATH_DASHBOARD.general.dashboardHome,
      component: lazy(() => import('../views/DashboardHome')),
      mainNav:false,
    }
  ];
  if(selectorContext) {
    if (selectorContext.unit) {
      nav.push(
        {
          exact: true,
          path: PATH_DASHBOARD.general.configPage,
          component: lazy(() => import('../views/ConfigPage')),
          title:textContent.rootNavConfig,
          icon: <Settings/>
        }
      );
    }
  }
  return nav;
};


export const getSchoolRoutes = (profileContext,brand,mode='unset') => {

    const debug = false;

    let hasConfig = false;
    let superUser = false;
    let houseRedirect = '';
    
    if(!profileContext.isLoading && !profileContext.hasFailed){
      
      const {
        profile:{
          staffUserData=false,
          hasSuperRights=false,
        },
        profile=null
      } = profileContext;
      if(hasSuperRights){
        hasConfig = true;
        superUser= true;
      }
      if(staffUserData){
        const {
          hasConfigRight:staffHasConfig
        } = staffUserData;
        if(staffHasConfig){
          hasConfig = true;
        }
      }

      
      if(profile){
        const {staffUserData=null} = profile;
        if(staffUserData){
          const {SchoolHouse=null} = staffUserData;
          if(SchoolHouse){
              const {id:schoolHouseId=null} = SchoolHouse;
              houseRedirect = `?selectHouse=${schoolHouseId}`;
          }
        }
      }
    }
    
    const {textContent} = brand;
    

    let nav = [
      {
        exact: true,
        path: PATH_DASHBOARD.general.dashboardHome,
        queryString:houseRedirect,
        component: lazy(() => import('../views/DashboardHome')),
        title:textContent.navBarStudents,
        icon: <PeopleAlt/>
      },
      {
        exact: true,
        path: PATH_DASHBOARD.general.incoming,
        queryString:houseRedirect,
        component: lazy(() => import('../components/igtm/ReportViews/Bookings/RootBookingsIncoming')),
        title:textContent.navBarReturn,
        icon: <ArrowDownward/>
      },
      {
        exact: true,
        path: PATH_DASHBOARD.general.outgoing,
        queryString:houseRedirect,
        component: lazy(() => import('../components/igtm/ReportViews/Bookings/RootBookingsOutgoing')),
        title:textContent.navBarLeave,
        icon: <ArrowUpward/>
      },
      {
        exact: true,
        path: PATH_DASHBOARD.general.schoolTaxiBookings,
        component: lazy(() => import('../components/igtm/ReportViews/SchoolTaxiBookings/TaxiBookingPageOuter')),
        title:textContent.navBarTaxi,
        icon: <LocalTaxi/>
      },
      {
        exact: true,
        path: PATH_DASHBOARD.general.studentPage,
        component: lazy(() => import('../components/igtm/DetailViews/StudentDetail/StudentDetailContainer')),
        mainNav:false
      },
      {
        exact: true,
        path: PATH_DASHBOARD.general.trackTaxi,
        component: lazy(() => import('../components/igtm/TaxiTracking/TrackTaxi')),
        mainNav:false
      },
    ];
    
    
    if(hasConfig){
      nav.push({
        exact: true,
        path: PATH_DASHBOARD.general.configPage,
        component: lazy(() => import('../views/ConfigPage')),
        title:textContent.rootNavConfig,
        icon: <Settings/>
      });
    }

    if(superUser){
      nav = [...nav,...[
          {
            exact: true,
            path: PATH_DASHBOARD.general.reportingPage,
            component: lazy(() => import('../components/igtm/SchoolReporting/SchoolReportingOuter')),
            title:textContent.navReporting,
            icon: <QueryStats/>
          },
          {
            exact: true,
            path: `${PATH_DASHBOARD.general.reportingPage}/:tabKey`,
            component: lazy(() => import('../components/igtm/SchoolReporting/SchoolReportingOuter')),
            mainNav:false
          },
          {
            exact: true,
            path: PATH_DASHBOARD.general.travelDayReporting,
            component: lazy(() => import('../components/igtm/SchoolReporting/Widgets/TravelDayReporting/TDReportingOuter')),
            mainNav:false
          },
          {
            exact: true,
            path: '/compliancereporting/:period',
            component: lazy(() => import('../components/igtm/SchoolReporting/Widgets/ComplianceReporting/ComplianceReportingOuter')),
            mainNav:false
          },
          {
            exact: true,
            path: PATH_DASHBOARD.general.coachBookingsDash,
            component: lazy(() => import('../components/igtm/ReportViews/CoachBookings/CoachBookingsDash')),
            mainNav:false
          },
        ]
      ];
    }
    if(debug){
      console.log(nav,mode);
    }
    return nav;
};


